import { Button } from "#components/v2/Button";
import {
  SingleSelectDropdown,
  SingleSelectDropdownItem,
} from "#components/v2/SingleSelectDropdown";
import { useFreshworksWidget } from "#hooks/useFreshworksWidget";
import { InfoIconBold } from "#icons";

export type SupportMenuDisplay = "button" | "link";

export interface SupportMenuProps {
  userName: string;
  userEmail: string;
  display?: SupportMenuDisplay;
}

export function SupportMenu({ display = "button", userName, userEmail }: SupportMenuProps) {
  const { open: openFreshworksWidget } = useFreshworksWidget(userEmail, userName);

  const openHelpPortal = () => {
    window.open("https://stacklet.freshdesk.com/", "_blank");
  };

  if (display === "button") {
    return (
      <SingleSelectDropdown
        AnchorEle={
          <Button
            aria-controls="menu-appbar"
            aria-haspopup="true"
            aria-label="support"
            className="hover:bg-transparent hover:text-brand-primary focus:bg-transparent focus:text-neutral-700"
            variant="tertiary"
          >
            <InfoIconBold className="h-lg w-lg" />
          </Button>
        }
      >
        <SingleSelectDropdownItem onPress={openFreshworksWidget}>
          Contact Support
        </SingleSelectDropdownItem>
        <SingleSelectDropdownItem onPress={openHelpPortal}>
          Explore Help Portal
        </SingleSelectDropdownItem>
      </SingleSelectDropdown>
    );
  }

  return (
    <a
      className="cursor-pointer text-label-large underline"
      onClick={openFreshworksWidget}
      role="button"
    >
      Support
    </a>
  );
}
